import React from 'react'

export default function PercentOffBatchSetFormStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .wrapper {
          display: flex;
          flex-direction: column;
          justify-content: stretch;
          height: 90%;
          box-sizing: border-box;
        }

        /******* Form Container **********/
        .form-container { width: 100%; font-size: 1rem; }

        .input-container { width: 70%; padding: 5px; display: flex; }
        .input-container label { flex: 1; font-size: 0.95rem; }
        .input-container input { padding: 5px; }

        #percent-off { width: 20%; }
        #percent-off-remarks { width: 100%; }

        .input-container .percent-off-input-container { flex: 2; }
        .input-container .percent-off-remarks-input-container { flex: 2; }

        .input-container .percent-off-input-container input { width: 20%; text-align: right; }
        .input-container .percent-off-remarks-input-container input { width: 100%; }

        /****** Products List Container *******/
        .products-list-container {
          flex: 1;
          box-sizing: border-box;
          padding: 3px;
          border: solid 0.5px grey;
          overflow: auto;
        }

        .table-container {
          font-size: 1rem;
          margin-bottom: 5px;
          padding: 2px;
        }
        .table-container:last-child { margin-bottom: 0; }

        .products-list-table {
          border-top: solid 1px black;
          width: 100%;
          box-sizing: border-box;
          border-spacing: 0;
        }
        .products-list-table td { padding: 2px; }
        .products-list-table td:nth-child(1) { width: 2%; }
        .products-list-table td:nth-child(2) { width: 68%; }
        .products-list-table td:nth-child(3) { width: 30%; }

        .products-list-table tr:hover {
          background-color: rgba(22, 22, 205, 0.05);
        }

        /****** Action Button List Container *******/
        .action-button-container {
          margin-top: 10px;
          display: flex;
          justify-content: flex-end;
        }
      `}
      </style>
    </React.Fragment>
  )
}
